export default "__VITE_ASSET__z4IcSUjx__"